export const BASE_URL = process.env.REACT_APP_BASEURL;
export const BASE_VERSION = process.env.REACT_APP_BASEVERSION;